import { type EnvironmentProviders } from '@angular/core';

import {
  SapOdataPurchaseRequisitionsPermissions,
  createTransferPurchaseRequisitionClientSettingsPlugin,
} from '@mp/integrations/sap-odata/document-management/purchase-requisitions/feature';
import { provideModuleInfo } from '@mp/shared/util';
import { provideModuleOrganizationSettings, provideModulePermissions } from '@mpk/shared/data-access';
import { SAP_SETTINGS_GROUP } from '@mpk/shared/util';

const moduleName = 'SapOdata';
export function provideSapOdataFeature(): EnvironmentProviders[] {
  return [
    provideModuleInfo(moduleName, {
      displayName: 'SAP OData',
    }),
    provideModulePermissions(moduleName, SapOdataPurchaseRequisitionsPermissions),
    // Die BANF-Übertragung liegt in der gemeinsamen SAP-Gruppe, nicht in einer eigenen Modulgruppe.
    provideModuleOrganizationSettings(SAP_SETTINGS_GROUP, createTransferPurchaseRequisitionClientSettingsPlugin),
  ];
}
